export const typeForm = {
    activate: 'activar',
    verify: 'verificar',
};

export enum StatusUserTypes {
    ACTIVE = 1,
    VERIFIED = 0
}


export const getStatusStr = {
    [StatusUserTypes.ACTIVE]: 'Activo',
    [StatusUserTypes.VERIFIED]: 'Verificado'
};

export enum SourceTypes {
    CS = 1,
}


export const getSourceStr = {
    [SourceTypes.CS]: 'CS',
};